var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('v-stepper',{attrs:{"vertical":"","non-linear":"","elevation":"2"},model:{value:(_vm.currentQuestion),callback:function ($$v) {_vm.currentQuestion=$$v},expression:"currentQuestion"}},_vm._l((_vm.questions.questions),function(question,index){return _c('question',{key:index,attrs:{"question":{
        question: question,
        options: _vm.questions.options[index],
        questionNumber: index + 1,
      },"currentQuestion":_vm.currentQuestion},on:{"nextQuestion":function($event){_vm.currentQuestion++}}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }